var CareerService = (function () {

    'use strict';

    //************ Functions ************//
    function clear() {
        $('.js-mod-add-profile-age').val("");
        $('.js-mod-add-profile-name').val("");
        $('.js-mod-add-profile-phone').val("");
        $('.js-mod-add-profile-city').val("");
        $('.js-mod-add-profile-education').val("");
        $('.js-mod-add-profile-career').val("");
        $('.js-mod-add-profile-comment').val("");
        $('.js-mod-add-profile-history').val("");
    }

    function init() {
        $('.js-mod-add-profile-button').on('click', function() {
            $('.js-mod-add-profile-button').attr('disabled', 'disabled').addClass('disabled');
            var age = $('.js-mod-add-profile-age').val();
            var name = $('.js-mod-add-profile-name').val();
            var phone = $('.js-mod-add-profile-phone').val();
            var city = $('.js-mod-add-profile-city').val();
            var education = $('.js-mod-add-profile-education').val();
            var career = $('.js-mod-add-profile-career').val();
            var about = $('.js-mod-add-profile-comment').val();
            var history = $('.js-mod-add-profile-history').val();
            var agreement = $('.js-mod-add-profile-agreement').is(':checked');

            var isValidate = true;

            if (name == '') {
                isValidate = false;
                $('.js-mod-add-profile-name').addClass('has-error');
            }


            var strPhone = phone.split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

            if (strPhone.length < 11) {
                isValidate = false;
                $('.js-mod-add-profile-phone').addClass('has-error');
            }

            if (career == null || career == 'Выберите вакансию') {
                isValidate = false;
                $('.js-mod-add-profile-career').addClass('has-error');
            }

            if (education == '') {
                isValidate = false;
                $('.js-mod-add-profile-education').addClass('has-error');
            }

            if (city == '') {
                isValidate = false;
                $('.js-mod-add-profile-city').addClass('has-error');
            }

            if (about == '') {
                isValidate = false;
                $('.js-mod-add-profile-comment').addClass('has-error');
            }

            if (agreement == false) {
                isValidate = false;
                $('.js-mod-add-profile-agreement-form').addClass('has-error');
            }

            if (!isValidate) {
                $('.js-mod-add-profile-button').removeAttr('disabled').removeClass('disabled');
                return;
            }

            AppService.toggleLoader();
            $.ajax({
                url: '/resume/add',
                type: 'post',
                data: {
                    name: name,
                    phone: phone,
                    careerId:career,
                    about: about,
                    age: age,
                    education: education,
                    city: city,
                    history: history
                },
                success: function(response) {
                    if (response.code == '200') {
                        clear();
                        $('#modalAddProfile').modal('hide');
                        $('.js-modal-success-message').html(
                            'Ваша заявка принята.<br>' +
                            'Мы рассмотрим её<br>' +
                            'в ближайшее время.'
                        );
                        AppService.toggleLoader();
                        $('#modalSuccess').modal('show');
                    }
                },
                error: function () {
                    AppService.toggleLoader();
                    $('.js-mod-add-profile-button').removeAttr('disabled').removeClass('disabled');
                }
            });
        });

        $('.js-career-city-item').click(function() {
            var $this = $(this);
            $('.js-career-item').hide();
            $('.js-career-city-item').removeClass('mod-current');
            $this.addClass('mod-current');
            $('.js-career-city-link').text($this.text());
            $('#modalCareerCitySelector').modal('hide');
            $(".js-career-item[data-city-id='" + $this.data('id') + "']").show();
        });
    }

    //************ section scroll ************//



    $(function() {
        var width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        var footerHeight = $('.navbar-fixed-bottom').height();
        var headerHeight = $('.navbar-fixed-top').height();
        var sectionPadding = footerHeight + headerHeight;



        if (width>768) {
            $('.career').fullpage({
                scrollOverflow : true,
                paddingBottom : sectionPadding + 'px',
                slideSelector: '.slides',
                normalScrollElements: '.modal',
                css3:false,
                fitToSection: false,
                easing: 'easeInOutCubic',
                scrollOverflowOptions: {
                    scrollbars: true,
                    mouseWheel: true,
                    hideScrollbars: true,
                    fadeScrollbars: true,
                    disableMouse: true,
                    interactiveScrollbars: true
                }
            });
        }

        $('.career-carousel').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.review-carousel').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    });





    //************ Public ************//
    return {
        init: init
    };
})();

$(CareerService.init);